<template>
  <v-container fluid class="py-0 px-2">
    <v-text-field
      v-model="search"
      background-color="colorSearchSettings"
      clearable
      :append-icon="mdiMagnify"
      :label="$t('label.search')"
      hide-details
    ></v-text-field>
    <div style="min-height: 1px"></div>
    <v-data-table
      :headers="headers"
      :items="tableData"
      item-key="id"
      :height="$store.state.windowSize.y - 150"
      :search="search"
      fixed-header
      must-sort
      disable-pagination
      hide-default-footer
      class="tableCursor"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.identifier }}</td>
          <td>{{ item.note }}</td>
          <td>{{ item.areasString }}</td>
          <td
            v-if="$store.state.auth.userSettings.accCards.update"
            class="px-2 tableSelectCursor"
            @click="((modalEdit = true), (card = { ...item }))"
          >
            <v-icon>{{ mdiPen }}</v-icon>
          </td>
          <td v-else></td>
        </tr>
      </template>
    </v-data-table>
    <v-row>
      <v-col cols="3">
        <v-btn v-if="$store.state.auth.userSettings.accCards.write" block color="colorNew" @click="dataNew">
          {{ $t('label.addNew') }}
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col cols="2">
        <v-btn v-if="$store.state.auth.userSettings.accEmployees.export" block color="colorExport" href="/api/v1/export/cards">
          {{ $t('btn.export') }}
          <v-icon>{{ mdiExport }}</v-icon></v-btn
        >
      </v-col>
      <v-col cols="2">
        <v-btn v-if="$store.state.auth.userSettings.accEmployees.import" block color="colorImport" @click="modalImport = true">
          {{ $t('btn.import') }}
          <v-icon>{{ mdiImport }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!----------DIALOGS------------------------------>
    <v-dialog v-model="modalEdit" persistent width="70%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.visitorcard') }}
          <v-spacer />
          <v-icon large @click="modalEdit = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-form v-model="validForm" ref="cardForm">
            <v-row>
              <v-col>
                <v-tooltip bottom :open-delay="1000">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :label="$t('label.identifier')"
                      v-model="card.identifier"
                      :rules="[ruleRequired]"
                      maxlength="128"
                      hide-details
                      dense
                      required
                      v-on="on"
                      autofocus
                    />
                  </template>
                  <span>{{ $tc('tt.cardIdentifier') }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-tooltip bottom :open-delay="1000">
                  <template v-slot:activator="{ on }">
                    <v-text-field :label="$t('label.code')" v-model="card.code" hide-details dense maxlength="64" v-on="on"></v-text-field>
                  </template>
                  <span>{{ $tc('tt.cardCode') }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model="card.areas"
                  :label="$tc('label.area', 2)"
                  :items="listAreas"
                  item-text="name"
                  item-value="id"
                  :rules="[ruleArray]"
                  :return-object="false"
                  multiple
                  chips
                  deletable-chips
                  :menu-props="{ minWidth: '500' }"
                  append-icon
                  hide-details
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea :label="$t('label.note')" v-model="card.note" name="input-7-1" maxlength="512" no-resize />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-btn v-if="card.id && $store.state.auth.userSettings.accCards.delete" color="colorDelete" @click="modalDelete = true">
            {{ $t('btn.delete') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="colorSave" @click="dataSave">{{ $t('btn.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalImport" max-width="60vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('label.import') }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="importEvent"
                :label="$t('label.action')"
                :items="listImportEvents"
                hide-details
                append-icon
                auto-select-first
              />
            </v-col>
            <v-spacer />
            <v-col cols="2">
              <v-progress-circular v-if="importProgressStatus" :size="40" color="green" indeterminate />
            </v-col>
            <v-col cols="3">
              <v-btn block color="colorImport" class="mt-2">
                <label for="appLogFileInput">{{ $t('btn.csvFile') }}</label>
                <input
                  id="appLogFileInput"
                  v-on:change="((importFile = $event.target.files), (importFileName = $event.target.files[0].name))"
                  type="file"
                  hidden
                />
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <h3>{{ importFileName }}</h3>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn tile color="colorImport" @click="dataImport">{{ $t('btn.import') }}</v-btn>
          <v-spacer />
          <v-btn tile color="colorClose" @click="modalImport = false">{{ $t('btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}: ${card.identifier}?`"
      :openDialog.sync="modalDelete"
      v-on:confirm="dataDelete"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';

import { mdiMagnify, mdiPen, mdiClose, mdiExport, mdiImport } from '@mdi/js';

export default Vue.extend({
  name: 'SettingsCards',
  components: { DialogConfirmDelete },
  data: () => ({
    modalEdit: false,
    modalDelete: false,
    modalImport: false,
    validForm: false,
    tableData: [],
    listAreas: [],
    search: '',
    card: {
      id: 0,
      identifier: null,
      code: '',
      note: null,
      areas: [] as any,
    },
    importFile: '',
    importFileName: '',
    importProgressStatus: false,
    importEvent: 'append',
    mdiMagnify: mdiMagnify,
    mdiPen: mdiPen,
    mdiClose: mdiClose,
    mdiExport: mdiExport,
    mdiImport: mdiImport,
  }),
  computed: {
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
    ruleArray() {
      return (v: any) => !!(v.length > 0) || this.$i18n.t('msg.fieldIsMandatory');
    },
    headers: function () {
      return [
        { text: this.$i18n.t('label.identifier'), value: 'identifier', width: '200px' },
        { text: this.$i18n.t('label.note'), value: 'note', width: '250px' },
        { text: this.$i18n.tc('label.area', 2), value: 'areasString' },
        { sortable: false, width: '48px' },
      ];
    },
    listImportEvents: function () {
      return [
        { text: this.$i18n.t('label.append'), value: 'append' },
        { text: this.$i18n.t('label.rewrite'), value: 'rewrite' },
      ];
    },
  },
  mounted() {
    this.listAreasLoad();
    this.$nextTick(function () {
      this.dataLoad();
    });
  },
  methods: {
    dataLoad() {
      axios
        .get(`/api/v1/card`)
        .then((response) => {
          this.tableData = response.data;
          for (const row of response.data) {
            row.areasString = ''; // String nazvov prostoru
            if (row.areas !== null) {
              for (const cardArea of row.areas) {
                let area: any;
                for (area of this.listAreas) {
                  if (area.id === cardArea) {
                    row.areasString = row.areasString + ', ' + area.name;
                  }
                }
              }
            }
            row.areasString = row.areasString.substring(2);
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataNew() {
      const getDefaults: any = this.$options;
      this.card = { ...getDefaults.data().card };
      this.modalEdit = true;
      this.$nextTick(function () {
        const form: any = this.$refs.cardForm;
        form.validate();
      });
    },
    dataSave() {
      const form: any = this.$refs.cardForm;
      if (form.validate() !== true) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
      } else {
        if (this.card.id === 0) {
          axios
            .post('/api/v1/card', this.card)
            .then((response) => {
              if (response.data.status === 'recordExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.identifierExists'));
              } else {
                this.dataLoad();
                this.modalEdit = false;
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          axios
            .put('/api/v1/card', this.card)
            .then((response) => {
              if (response.data.status === 'recordExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.identifierExists'));
              } else {
                this.dataLoad();
                this.modalEdit = false;
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    dataDelete() {
      axios
        .delete(`/api/v1/card/${this.card.id}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.modalDelete = false;
      this.modalEdit = false;
    },
    listAreasLoad() {
      axios
        .get('/api/v1/area')
        .then((response) => {
          this.listAreas = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataImport() {
      if (this.importFileName === '') {
        this.$store.commit('globalMessage', this.$i18n.t('msg.selectImportFile'));
        return;
      }
      this.importProgressStatus = true;
      const formData = new FormData();
      formData.append('upload', this.importFile[0]);
      axios
        .post(`/api/v1/import/cards/${this.importEvent}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          this.importProgressStatus = false;
          this.listAreasLoad();
          this.dataLoad();
          this.modalImport = false;
        })
        .catch((err) => {
          this.importProgressStatus = false;
          this.$store.dispatch('catchErrHandler', err);
        });
    },
  },
});
</script>
